import { useCallback, useEffect, useMemo, useRef } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './css/overridesquill.css'
import { formats } from './config.js';
import registerBlots from './BlotsRegistration.js'; // Appelle la fonction pour enregistrer les blots

const QuillEditor = ({ content, onChange, readOnly = false, style }) => {
  const quillRef = useRef();

  // Enregistre les blots une seule fois
  useEffect(() => {
    registerBlots();
  }, []);


  useEffect(() => {
    if (!quillRef.current) return; // Vérifie que Quill est bien monté avant d'accéder à son instance
  
    const quill = quillRef.current.getEditor();
    
    if (quill && typeof content === 'string') {
      const delta = quill.clipboard.convert(content);
      quill.setContents(delta);
    }
  
    return () => {
      if (quill) {
        quill.off(); // Déconnecter tous les écouteurs d'événements
        quill.root.innerHTML = ''; // Nettoyer le contenu pour éviter les erreurs de référence
      }
    };
  }, [content]);
  

  const modules = useMemo(() => ({
    toolbar: readOnly ? null : { container: "#toolbar-container" }
  }), [readOnly]);

  const getContentHash = (content) => {
    if (!content) return "empty";
    let hash = 0;
    for (let i = 0; i < content.length; i++) {
      const char = content.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash |= 0; // Convertit en entier 32 bits
    }
    return hash.toString();
  };  

  const contentHash = useMemo(() => getContentHash(content), [content]);

  return (
     <div
          translate={'no'}
          className={'notranslate'}
        >
    <ReactQuill
      ref={quillRef}
      key={`${readOnly}-${contentHash}`} // Force le re-render proprement
      theme="snow"
      value={content || ""}
      modules={modules}
      formats={formats}
      onChange={onChange}
      style={style}
      readOnly={readOnly}
      className="no-border-quill"
    />
    </div>
  );
};

export default QuillEditor;